import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LabelImportantOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"label_important_outline"}/>
}
